// src/pages/Home.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      {/* HERO SECTION */}
      <section className="hero">
        <h1>Digital Document Signing</h1>
        <p>FAST • SECURE • PAPERLESS</p>
      </section>

      {/* MAIN CONTENT */}
      <div className="main-card-wrapper">
        <div className="home-card">
          {/* WORKFLOW */}
          <div className="workflow-box">
            <h3 className="section-title">Workflow Overview</h3>
            <div className="workflow-list">
              <div className="workflow-item">
                <span className="workflow-num">1</span>
                <span>Create Signature</span>
              </div>
              <div className="workflow-item">
                <span className="workflow-num">2</span>
                <span>Save Securely</span>
              </div>
              <div className="workflow-item">
                <span className="workflow-num">3</span>
                <span>Upload Document</span>
              </div>
              <div className="workflow-item">
                <span className="workflow-num">4</span>
                <span>Sign & Finalize</span>
              </div>
            </div>
          </div>

          {/* ACTIONS */}
          <div>
            <h3 className="section-title">Quick Actions</h3>
            <div className="actions-grid">
              <button
                className="action-btn action-btn-primary"
                onClick={() => navigate("/createsign")}
              >
                Create Signature
              </button>

              <button
                className="action-btn action-btn-secondary"
                onClick={() => navigate("/viewsign")}
              >
                View Signature
              </button>

              <button
                className="action-btn action-btn-secondary"
                onClick={() => navigate("/UploadSign")}
              >
                Upload & Sign
              </button>

              <button
                className="action-btn action-btn-secondary"
                onClick={() => {}}
              >
                View Documents
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="footer">
        <p>© 2025 DigitalDocSign. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Home;